import { Mui } from "@osu/react-ui";

const styles = {
  root: {
    display: "flex",
    justifyContent: 'space-between',
  },
  requiredSubselectionInstructions: {
    fontSize: "90%",
  },
  placeholderWidth: {
    visibility: "hidden",
  },
};

const Notes = (props) => {
  const {
    renderInputControls,
    studentData
  } = props;
  
  function requirementInstructionsEle(areaName) {
    return [
        <Mui.Typography key={`${areaName}-instruction`} sx={styles.requiredSubselectionInstructions}>* A subfield is required when you select {areaName}</Mui.Typography>,
        <Mui.Typography key={`${areaName}-instruction-placeholder`} sx={{ ...styles.requiredSubselectionInstructions, ...styles.placeholderWidth }}>* A subfield is required when you select {areaName}</Mui.Typography>
    ];
  }
   
  return (
    <Mui.Container>
        <Mui.Box sx={styles.root}>
            <Mui.FormControl component="fieldset">
                <Mui.FormGroup>{renderInputControls(studentData?.data?.notes?.evaluation, "evaluation", ...requirementInstructionsEle("college prep"))}</Mui.FormGroup>
            </Mui.FormControl>
            <Mui.FormControl component="fieldset">
                <Mui.FormGroup>{renderInputControls(studentData?.data?.notes?.document, "document", ...requirementInstructionsEle("other document"))}</Mui.FormGroup>   
            </Mui.FormControl>
            <Mui.FormControl component="fieldset">
                <Mui.FormGroup>{renderInputControls(studentData?.data?.notes?.othersConcerns, "othersConcerns")}</Mui.FormGroup>
            </Mui.FormControl>
        </Mui.Box>
    </Mui.Container>
  );
};

export default Notes;
